// extracted by mini-css-extract-plugin
module.exports = {"switcherWrap":"styles_switcherWrap__1dNYp","switcherImg":"styles_switcherImg__2D47p"};